import CollectionsPanel from './CollectionsPanel';

export default CollectionsPanel;
